import { Text18Size, TitleH1 } from "components/generic";
import { Trans, useTranslation } from "react-i18next";
import { LiItem } from "../FindRoom/styles";
import { HomeDiv, ItemLink, LimitWidthSection } from "../styles";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/intarfaces";

export const Cookies = () => {
  const { t } = useTranslation("cookies");

  const textLines: string[] = t("text", { returnObjects: true });
  const links: React.ReactNode[] = (
    t("links", { returnObjects: true }) as string[]
  ).map((link) => (
    <ItemLink
      href={link!}
      target={`${link.startsWith("#") ? "_self" : "_blank"}`}
    />
  ));
  const seo = t("seo", { returnObjects: true }) as ISeo;

  return (
    <HomeDiv>
    {seo && <HeaderSEO {...seo} />}
      <LimitWidthSection style={{ textAlign: "left" }}>
        <TitleH1 m="0 0 24px 0">{t("title")}</TitleH1>
        {textLines.length &&
          textLines.map((_, num) => (
            <Trans
              t={t}
              i18nKey={"text." + num}
              parent={Text18Size}
              components={
                [
                  <LiItem style={{ padding: "0 0 0 20px" }} />,
                  ...links
                ] as any[]
              }
              key={num}
            />
          ))}
      </LimitWidthSection>
    </HomeDiv>
  );
};
